import axios from 'axios'
import moment from 'moment'
import { Message } from 'element-ui';
import _ from 'lodash'

export function getByteLen(str) {
  var len = 0;
  for (var i = 0; i < str.length; i++) {
    var ch = str.charCodeAt(i);
    if (ch >= 0 && ch <= 128) {
      len += 1;
    } else {
      len += 2;
    }
  }
  return len;
}

const colors = [
  {
      "min": 0,
      "max": 10,
      "bgcolor": "#67ce0b",
      "fgcolor": "#ffffff",
  },
  {
      "min": 10,
      "max": 20,
      "bgcolor": "#f2d62d",
      "fgcolor": "#ffffff",
  },
  {
      "min": 20,
      "max": 30,
      "bgcolor": "#fa8a04",
      "fgcolor": "#ffffff",
  },
  {
      "min": 30,
      "max": 40,
      "bgcolor": "#f80302",
      "fgcolor": "#ffffff",
  },
  {
      "min": 40,
      "max": 50,
      "bgcolor": "#cf0000",
      "fgcolor": "#ffffff",
  },
  {
      "min": 50,
      "max": 100,
      "bgcolor": "#970454",
      "fgcolor": "#ffffff",
  },
]

var layerOptions = [
  {
    label: "加油站/加气站",
    value: "加油站/加气站",
    icon: "加油站_加气站"
  },
  { label: "汽修厂", value: "汽修厂", icon: "汽修厂" },
  { label: "加气站", value: "加气站", icon: "加气站" },
  { label: "加油站", value: "加油站", icon: "加油站" },
  { label: "二污普排放源", value: "二污普排放源", icon: "二污普排放源" },
  { label: "餐饮企业", value: "餐饮企业", icon: "餐饮企业" }
];

class AermodLayer extends nMap.CanvasCommonLayer {
  constructor(map, data, optsParam, dataCallback) {
    let imgSrc = `https://webfron.czczh.net/static/images/icon/加油站_加气站.png`;

    let optsDefault = {
      // 绘制图标还是圆点
      drawMode: 'icon',
      drawText: false,
      zIndex: 100,
      icon: {
        img: imgSrc,
        width: 15,
        height: 20,
        deg: 0,
        // offset: {
        //   x: -7.5,
        //   y: -20
        // }
      },
      point: {
        size: 10,
        fillStyle: 'red'
      },
      text: {
        textKey: 'name',
        textAlign: 'center',
        textBaseline: 'middle',
        font: '14px sans-serif',
        fillStyle: 'black',
        offset: {
          x: 7.5,
          y: -6
        }
      },
      events: {
        click(item, map, zIndex) {
          var content = `
            <div style=\"padding:7px 0px 0px 0px;\">
              <p class='input-item'>${item.name}</p>
          `
          if (item.data_json) {
            for (let k in item.data_json) {
              content += `<p class='input-item'>${k}: ${item.data_json[k]}</p>`
            }
          }
          content += `</div>`
          var infoWindow = new BMap.InfoWindow(content, {
            zIndex: zIndex,
          });
          map.openInfoWindow(infoWindow, new BMap.Point(item.lng, item.lat))
        }
      }
    }
    let opts = Object.assign(optsDefault, optsParam)
    console.log(opts);
    super(map, data, opts)
    this.dataCallback = dataCallback
    this.circleLayer = null
  }

  getData(station, tm, roundType, dist) {
    console.log(station, tm);
    let gcj = coordtransform.bd09togcj02(station.Lng, station.Lat)
    let wgsCoord = coordtransform.gcj02towgs84(gcj[0], gcj[1])
    let lng = Math.round(wgsCoord[0] * 10000)/10000
    let lat = Math.round(wgsCoord[1] * 10000)/10000

    // lat = 36.686075
    // lng = 117.061996
    // 时间点
    var tmStr = moment(tm).subtract(8, 'hours').format('YYYYMMDDHHmm')
    let url = `http://jnwz.novaecs.com/167/napi/get-pollution-source?time=${tmStr}&lat=${lat}&lng=${lng}&high=2&round_type=${roundType}&sid=${station.station_id}`
    if (roundType === 'circle') {
      url += `&dist=${dist}`
      this.drawCircle(station, dist)
    }else {
      this.removeCircle()
    }
    axios.get(url).then(x=>{
      console.log(x.data.data);
      let {data} = x.data
      data = _.sortBy(data, (x) => x[this.opts.sensorType + '_rate']) 
      this.setData(data)
      this.dataCallback(x.data.data)
    }).catch(e=>{
      this.setData([])
      this.dataCallback([])
      console.log(e);
      Message.info((e.data && e.data.msg) || '获取数据失败')
    })
    
  }

  drawCircle(station, dist) {
    this.removeCircle()
    // 绘制圆
    console.log(station);
    this.circleLayer = new BMap.Circle(new BMap.Point(station.Lng, station.Lat), dist, {
      strokeColor: 'blue',
      fillOpacity: 0.001,
      strokeWeight: 2,
      strokeOpacity: 1,
    });
    this.map.addOverlay(this.circleLayer);
  }

  removeCircle() {
    if (this.circleLayer) {
      this.map.removeOverlay(this.circleLayer)
      this.circleLayer = null
    } 
  }

  destroy() {
    super.destroy()
    this.removeCircle()
  }

  getColor(val) {
    for (let i of colors) {
      if (val <= i.max && val > i.min) {
        return i
      }
    }
  }

  drawItem(ctx, item) {
    super.drawItem(ctx, item)
    
    let {x, y} = item
    let val = item[this.opts.sensorType + '_rate']
    const text = val < 0.1 ? '<' : '' + `${val}%`
    const height = 22
    const widOff = this.opts.icon.width / 2 + 3
    let strLen = getByteLen(text)
    let x_width = strLen * 18
    if (x_width < 80) x_width = 80

    
    const colorInfo = this.getColor(val)
    console.log(colorInfo);
    console.log(val);
    ctx.fillStyle = colorInfo.bgcolor
    ctx.fillRect(x + widOff, y - height, x_width, height);
    ctx.strokeStyle = colorInfo.bgcolor
    ctx.lineWidth = 0;
    ctx.strokeRect(x + widOff, y - height, x_width, height);
    
    ctx.textAlign = "center";
    ctx.textBaseline = "bottom";
    ctx.font = "bold 16px Arial";
    ctx.fillStyle = colorInfo.fgcolor
    ctx.fillText(text, x + x_width / 2 + 12, y );
    ctx.fill();
  }
}

export default AermodLayer


// WEBPACK FOOTER //
// ./src/utils/aermodLayer.js